/** @jsx isolateComponent */
import { isFunction } from 'lodash';

import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Typography } from '@zapier/design-system';

import { SizeType } from '@zapier/product-get-help/src/types';

import Surface from '@zapier/product-get-help/src/components/shared/Surface';

import GeneralDocs from './GeneralDocs';
import AppDocs from './AppDocs';

type DocsStepProps = {
  /** Title */
  title: string;
  /** Children to render between the title and docs */
  children: React.ReactNode | (() => React.ReactNode);
  /** General docs to link */
  links?: Array<{
    href: string;
    title: string;
  }>;
  /** Apps to link docs for */
  apps?: Array<{
    id: string;
    name: string;
    slug: string;
    isPublic: boolean;
  }>;
  /** Size to display. */
  size?: SizeType;
};

const Styles = () => ({
  title: {
    ...Typography.sectionHeader1,
    color: Colors.gray,
  },
  children: {
    ...Typography.paragraph3,
    color: Colors.neutral800,
  },
  root: {
    display: 'grid',
    gridGap: 20,
  },
});

/** Renders the content for the docs-step in the form. */
const DocsStep = ({
  size = 'large',
  title,
  children,
  links,
  apps,
}: DocsStepProps) => {
  return (
    <Surface size={size} title={title}>
      <div css={Styles().root}>
        <div css={Styles().children}>
          {isFunction(children) ? children() : children}
        </div>
        {links && links.length > 0 && <GeneralDocs links={links} />}
        {apps && apps.length > 0 && <AppDocs apps={apps} />}
      </div>
    </Surface>
  );
};

export default DocsStep;
